<template>
  <default-layout v-if="id">
    <h1 class="title is-h1">Update Trainer</h1>
    <form @submit.prevent="handleSubmit">
      <trainer-form :trainer="trainer" @data="data = $event"></trainer-form>
      <hr>
      <div class="buttons">
        <button type="submit" class="button is-primary">Update Trainer</button>
        <button class="button is-outlined" type="button" @click="backToTrainers()">Cancel</button>
      </div>
    </form>
  </default-layout>
</template>

<script>
import TrainerForm from '../components/trainers/TrainerForm.vue'
import DefaultLayout from '../layouts/DefaultLayout.vue'
import { trainerQuery, updateTrainerMutation } from '../graphql/trainers'

export default {
  components: {
    DefaultLayout,
    TrainerForm
  },
  data () {
    return {
      data: null
    }
  },
  apollo: {
    trainer: {
      query: trainerQuery,
      variables () {
        return {
          id: this.id
        }
      }
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    }
  },
  methods: {
    handleSubmit () {
      if (!this.data) {
        return
      }
      // submit
      this.$apollo.mutate({
        mutation: updateTrainerMutation,
        variables: {
          id: this.id,
          data: this.data
        }
      })
        .then(() => {
          this.$toast.open({
            message: 'Trainer updated',
            type: 'is-success'
          })
          this.backToTrainers()
        })
        .catch((e) => {
          this.$toast.open({
            message: e.message || e,
            type: 'is-danger',
            duration: 5000
          })
        })
    },
    // back to trainers
    backToTrainers () {
      this.$router.push({ name: 'trainers' })
    }
  }
}
</script>
